import CloseIcon from '@mui/icons-material/Close';
import { Alert, Box, Button, Card, CardContent, Divider, Drawer, List, ListItem, ListItemText, Typography } from '@mui/material';
import React, { useContext, useState } from 'react';
import { DrawerHeader } from '../../app-layout/side-nav/side-nav.utils';
import { AuthContext } from '../../../contexts/user-context/user-context';
import { UserType } from '../../../enums/users';
import { OrgSettingsContext } from '../../../contexts/org-settings-context';
import { isMobile, isTablet } from 'react-device-detect';
import { ShopifyOrderValidationResult } from '../../../interfaces/delivery-company/orders';
import { IconWithText } from '../styles/components';
import { Visibility } from '@mui/icons-material';
import dayjs from 'dayjs';

interface ShopifyValidationErrorsProps {
    shopifyOrderValidationResult: ShopifyOrderValidationResult[];
}

function ShopifyValidationErrors({
    shopifyOrderValidationResult
}: ShopifyValidationErrorsProps) {
  const [open, setIsOpen] = useState(false);
  const { color } = useContext(OrgSettingsContext);

  const toggleDrawer =
    (is_open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === 'keydown' &&
        ((event as React.KeyboardEvent).key === 'Tab' ||
          (event as React.KeyboardEvent).key === 'Shift')
      ) {
        return;
      }

      setIsOpen(is_open);
    };

  return (
    <Box sx={{mt: 2, mb: 2, maxWidth: "500px", margin: "auto"}}>

    <Alert severity="warning">
        You have {shopifyOrderValidationResult.length} Shopify order{shopifyOrderValidationResult.length > 1 ? "s" : ""} with validation errors.
        <br />
        Click <Box display={"inline-block"} sx={{cursor: "pointer", textDecoration: "underline"}} onClick={toggleDrawer(true)}> <IconWithText><b>here</b> <Visibility/></IconWithText></Box> to view the issues and fix them.
    </Alert>
      <Drawer
        style={{ zIndex: 10 }}
        anchor={'right'}
        open={open}
        onClose={toggleDrawer(false)} 
      >
        <DrawerHeader />
        <Box p={2} width={isMobile ? '100vw' : isTablet ? '60vw' : '40vw'}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Shopify Order Validation Errors
            </Typography>
            <CloseIcon
              sx={{ fontSize: 32, cursor: 'pointer', color: color }}
              onClick={() => setIsOpen(false)}
            />
          </Box>
          <Divider sx={{ my: 2 }} />

          {shopifyOrderValidationResult.map((order) => (
            <Card key={order.shopify_order_id} variant="outlined" sx={{ mb: 2 }}>
              <CardContent>
                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                  Order #{order.order_number}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Last validated: {dayjs(order.last_validation_at).format('MMM D, YYYY h:mm A')}
                </Typography>

                <List dense>
                  {order.errors.map((err, idx) => (
                    <ListItem key={idx}>
                      <ListItemText
                        primary={err}
                        primaryTypographyProps={{ color: 'error', fontSize: '0.9rem' }}
                      />
                    </ListItem>
                  ))}
                </List>

                <Box mt={2} textAlign="right">
                  <Button
                    variant="contained"
                    size="small"
                    sx={{ backgroundColor: color, textTransform: 'none' }}
                    href={order.shopify_order_url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View in Shopify
                  </Button>
                </Box>
              </CardContent>
            </Card>
          ))}
        </Box>
      </Drawer>
    </Box>
  );
}

export default ShopifyValidationErrors;
